import { jwtEnvAxios } from ".";

export function getAiAppsApi() {
  return jwtEnvAxios("ai-lab").get(`/app/detail`);
}

export function updateAiAppApi(id: string, data: any) {
  return jwtEnvAxios("ai-lab").put(`/app/${id}`, data);
}

export function createAiAppApi(data: any) {
  return jwtEnvAxios("ai-lab").post(`/app`, data);
}

export function deleteAiAppApi(id: string) {
  return jwtEnvAxios("ai-lab").delete(`/app/${id}?force`);
}

export function stopAiAppApi(id: string) {
  return jwtEnvAxios("ai-lab").put(`/app/${id}/stop`);
}

export function startAiAppApi(id: string) {
  return jwtEnvAxios("ai-lab").put(`/app/${id}/start`);
}

export function updateAiAppScalingApi(id: string, data: any) {
  return jwtEnvAxios("ai-lab").put(`/app/${id}/scalingstrategy`, data);
}

export function updateAiAppImageApi(id: string, data: any) {
  return jwtEnvAxios("ai-lab").put(`/app/${id}/image`, data);
}

export function getAiAppImagesApi(region: string) {
  return jwtEnvAxios("ai-lab").get(`/capabilities/region/${region}/app/image`);
}

export function getAiAppPartnersApi(region: string) {
  return jwtEnvAxios("ai-lab").get(`/partners/region/${region}/partner`);
}

//
export function getAiAppApi(id: string) {
  return jwtEnvAxios("ai-lab").get(`/app/${id}`);
}

export function getAiAppLogsApi(id: string) {
  return jwtEnvAxios("ai-lab").get(`/app/${id}/log`);
}

export function aiAppSynchronizationApi(id: string, data: any) {
  return jwtEnvAxios("ai-lab").post(`/app/${id}/datasync`, data);
}
